import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { RenderField, Validators } from '../../Layout/Form/Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as UserModule from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';

type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t: Function;
};
type Props = {
    toggleFormsVisibility: Function;
};
const ActivateUserBeginForm = (props: InjectedFormProps & ConnectedProps & Props) => {
    const { handleSubmit, pristine, submitting, t, userStore, toggleFormsVisibility } = props;
    return (
        <form className="form" onSubmit={handleSubmit}>
            <h2>{t('activateUserBeginForm')}</h2>
            {userStore.error.beginActivateUserErr && (
                <p className="form_field--error form_field--error_msg">{t(`errors:beginActivateUserComplete.${userStore.error.beginActivateUserErr.errorSubcode}`)}</p>
            )}
            {userStore.success.beginActivateUserSuccess && <p className="form_field--success form_field--success_msg">{t('beginActivateUserSuccess')}</p>}
            <p>
                <button className="btn btn--clean" onClick={() => toggleFormsVisibility()}>
                    {t('goBackToActivateAccountComplete')}
                </button>
            </p>

            <Field name="email" component={RenderField} type="text" placeholder={t('email')} label={t('email')} validate={[Validators.required, Validators.email]} />
            <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                {t('send')}
            </button>
        </form>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'activateUserBegin'
    })
)(ActivateUserBeginForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/UserSigning/Forms/_ActivateUserBeginForm.tsx